<!-- materials-main -->
<template>
  <div class="meterials">
    <div class="meterials-left">
      <ul class="zlr-menu">
        <li v-for="(item,index) in menuList"
            :key="index">
          <a :class="[curMenu.title === item.title?'active': '']"
             @click="linkHandle(item)">{{item.title}}</a>
        </li>
      </ul>
    </div>
    <div class="meterials-right">
      <iframe :src="curMenu.url"
              frameborder="0"></iframe>
      <ul class="attachments-down"
          v-if="curMenu.attachments&&curMenu.attachments.length">
        <li v-for="(item, index) in curMenu.attachments"
            :key="index"><a :href="item.url">{{item.title}} 下载 </a></li>
      </ul>
    </div>
  </div>
</template>

<script>
// less
import './materials.less'
// constant
import materials from '@/constant/materials'
import { mapState } from 'vuex'
import { getConractInfo } from '@/api/talents'
import { ossSecretLink } from '@/api/oss'

// components
export default {
  name: 'meterials-main',
  data () {
    return {
      menuList: [],
      curMenu: {}
    }
  },
  computed: {
    ...mapState({
      userRole (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    this.makeMaterials()
  },
  methods: {
    makeMaterials () {
      if (!this.userRole) return false
      let role = this.userRole
      // 调用接口--动态获取第一个合同的url
      getConractInfo().then(res => {
        if (res.data.contractInfo && res.data.contractInfo.activeContractUrl) {
          ossSecretLink({
            dir: res.data.contractInfo.activeContractUrl
          }).then(res => {
            materials[0].url = res.data.url
            let materialsArr = materials.filter(item => item.permissions.includes(role))
            this.curMenu = materialsArr[0]
            this.menuList = materialsArr
          })
        } else {
          let materialsArr = materials.filter(item => item.permissions.includes(role))
          this.curMenu = materialsArr[0]
          this.menuList = materialsArr
        }
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    linkHandle (item) {
      this.curMenu = item
    }
  },
  watch: {
    userRole () {
      this.makeMaterials()
    }
  }
}
</script>
<style lang='less' scoped>
.zlr-menu {
  width: 300px;
  list-style: none;
  a {
    display: inline-block;
    width: 100%;
    padding: 10px;
    color: rgba(0, 0, 0, 0.85);
  }
  li {
    width: 100%;
  }
  > li {
    > a {
      padding-left: 10px;
    }
  }
  &-child {
    a {
      padding-left: 20px;
      font-size: 12px;
    }
  }
  &-disabled {
    pointer-events: none;
  }
  a:hover {
    background-color: @c-primary;
    color: #ffffff;
  }
  a.active {
    background-color: @c-primary;
    color: #ffffff;
  }
}
iframe {
  width: 960px;
  min-height: calc(100vh);
}
.attachments-down {
  li {
    padding: 10px;
  }
}
</style>
